import script from "./ScenariosTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScenariosTab.vue?vue&type=script&setup=true&lang=ts"

import "./ScenariosTab.vue?vue&type=style&index=0&id=6e546d10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e546d10"]])

export default __exports__